// extracted by mini-css-extract-plugin
export default {"container":"SafeguardCheckHistory_container__pKqdD"};